const EMPTY_CONTACT = Object.freeze({ phone: '', email: '' })

/**
 * 代理商认证联系方式的前台兜底值。
 * TDC 与 8B 后端 DEFAULT_AGENT_CERTIFICATION_CONTACTS 对齐；IPC 留空以隐藏入口。
 */
export const DEFAULT_AGENT_CERTIFICATION_CONTACTS = Object.freeze({
  TDC: Object.freeze({
    phone: '15938747827（微信同号）、18926448016（微信同号）',
    email: 'tendasales@tenda.cn',
  }),
  IPC: EMPTY_CONTACT,
})

/**
 * @param {unknown} value
 * @returns {string}
 */
function trimContactField(value) {
  return typeof value === 'string' ? value.trim() : ''
}

/**
 * @param {unknown} salesOrganization
 * @returns {{ phone: string, email: string }}
 */
export function getDefaultAgentCertificationContact(salesOrganization) {
  const org = String(salesOrganization || '').toUpperCase()
  if (org === 'TDC') {
    return { ...DEFAULT_AGENT_CERTIFICATION_CONTACTS.TDC }
  }
  if (org === 'IPC') {
    return { ...DEFAULT_AGENT_CERTIFICATION_CONTACTS.IPC }
  }
  return { ...EMPTY_CONTACT }
}

/**
 * 接口成功时用返回值覆盖；空字段仅 TDC 保留兜底。IPC 空电话必须保持为空。
 *
 * @param {unknown} salesOrganization
 * @param {unknown} [apiContact]
 * @returns {{ phone: string, email: string }}
 */
export function resolveAgentCertificationContact(salesOrganization, apiContact) {
  const defaults = getDefaultAgentCertificationContact(salesOrganization)
  if (!apiContact || typeof apiContact !== 'object') {
    return defaults
  }

  const phone = trimContactField(apiContact.phone)
  const email = trimContactField(apiContact.email)
  if (String(salesOrganization || '').toUpperCase() === 'IPC') {
    return { phone, email }
  }

  return {
    phone: phone || defaults.phone,
    email: email || defaults.email,
  }
}
